import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20advogado%20especializado';

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="relative overflow-hidden" ref={ref} style={{ minHeight: '500px' }}>
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=premium%20modern%20law%20firm%20office%20with%20floor%20to%20ceiling%20panoramic%20windows%2C%20city%20skyline%20view%20at%20dusk%2C%20dark%20navy%20blue%20and%20gold%20interior%2C%20sophisticated%20legal%20workspace%2C%20architectural%20photography%2C%20dramatic%20lighting%2C%20professional%20corporate%20atmosphere%2C%20high%20end%20design&width=1920&height=600&seq=cta1&orientation=landscape"
        alt="LC Advogados – Recuperação de golpes bancários"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Gradient overlay */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(135deg, rgba(11,47,91,0.92) 40%, rgba(18,62,115,0.78) 100%)' }}
      />

      <div
        className="relative z-10 flex flex-col items-center justify-center text-center px-6 py-28"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 0.7s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        <span
          className="text-xs font-bold tracking-widest uppercase mb-4 inline-block"
          style={{ color: '#E1C67A' }}
        >
          Não espere mais
        </span>
        <h2 className="font-serif text-4xl lg:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl">
          Recupere seu dinheiro com{' '}
          <span style={{ color: '#C9A24A', fontStyle: 'italic' }}>ajuda especializada</span>
        </h2>
        <p className="text-white/80 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed">
          Cada dia que passa é um dia a menos para agir. Nossa equipe está pronta para defender seus direitos agora mesmo.
        </p>

        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-10 py-5 rounded-full font-bold text-lg cursor-pointer whitespace-nowrap transition-all duration-300 hover:scale-105 mb-4"
          style={{ background: '#C9A24A', color: '#0B2F5B', boxShadow: '0 12px 40px rgba(201,162,74,0.45)' }}
        >
          <i className="ri-whatsapp-line text-2xl" />
          Falar com advogado agora
        </a>

        <p className="text-white/50 text-sm">
          Atendimento imediato &bull; Sem compromisso &bull; Análise gratuita do caso
        </p>
      </div>
    </section>
  );
}
